import { openBlock as e, createElementBlock as l, createElementVNode as t } from "vue";
function p(i, h) {
  return e(), l("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 800 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    t("g", { "clip-path": "url(#clip0_1520_57548)" }, [
      t("path", {
        d: "M0 0H900V800H0V0Z",
        fill: "#CE1126"
      }),
      t("path", {
        d: "M-60 0H286V346H-60V0Z",
        fill: "white"
      }),
      t("path", {
        d: "M-60 0H113V346H-60V0Z",
        fill: "#002654"
      }),
      t("path", {
        d: "M-60 346H459V0",
        stroke: "white",
        "stroke-width": "6"
      }),
      t("path", {
        d: "M528 506L432 410H624L528 506ZM496 538L400 442V634L496 538ZM528 570L432 666H624L528 570ZM560 538L656 442V634L560 538Z",
        fill: "white"
      })
    ]),
    t("defs", null, [
      t("clipPath", { id: "clip0_1520_57548" }, [
        t("rect", {
          width: "800",
          height: "800",
          rx: "400",
          fill: "white"
        })
      ])
    ])
  ]);
}
export {
  p as default
};
